import React from 'react';
import { connect } from 'react-redux';
import { StoreState } from 'state/types';
import {
  getCreatedShiftData,
  RosterDayViewCreatedShiftData,
  RosterDayViewCreatedShiftType
} from 'state/Roster/RosterDayView';
import { RosterCellType } from '../../../../../../../components';
import { DayCreatedShift } from '../../../../../components';

type OwnProps = {
  cellType: RosterCellType;
  shiftType: RosterDayViewCreatedShiftType;
  userId: string;
  rowIndex: number;
};

type StateProps = {
  createdShiftData: RosterDayViewCreatedShiftData;
};

type DispatchProps = {};

type Props = OwnProps & StateProps & DispatchProps;

const DayUserCreatedShiftComponent = ({
  cellType,
  shiftType,
  createdShiftData: {
    shift,
    pairIndex,
    type: createdShiftType,
    ...restCreatedShiftData
  },
  userId,
  rowIndex
}: Props) => {
  if (
    !shift ||
    userId !== shift.user_id ||
    shiftType !== createdShiftType ||
    pairIndex !== rowIndex
  ) {
    return null;
  }

  return (
    <DayCreatedShift
      shift={shift}
      cellType={cellType}
      {...restCreatedShiftData}
    />
  );
};

const mapStateToProps = (state: StoreState): StateProps => ({
  createdShiftData: getCreatedShiftData(state)
});

const mapDispatchToProps: DispatchProps = {};

export const DayUserCreatedShift = connect(
  mapStateToProps,
  mapDispatchToProps
)(DayUserCreatedShiftComponent);
